import axios from 'axios'

const getApiClient = (store) => {
    let api = axios.create({
        baseURL: process.env.VUE_APP_API_URL,
        withCredentials: true
    });

    api.interceptors.request.use(function (config) {
        if (store.state.jwtToken !== null) {
            config.headers.Authorization = `Bearer ${store.state.jwtToken}`;
        }

        if (store.state.impersonatedUser !== null) {
            if (! config.params) {
                config.params = {}
            }
            config.params['_switch_user'] = store.state.impersonatedUser
        }

        return config;
    });

    return api
}

export default getApiClient
